import React, { useEffect, useState } from 'react';
import { Button, message, Popconfirm, Space, Table, Tag } from 'antd';
import { DeleteFilled, EditFilled, PlusOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';
import { formatRupiah } from '../../../../Components/Global';

const TableSample = ({ onData }) => {
    const [dataRFNumber, setDataRFNumber] = useState([]);

    const fetchDataLocalStorage = () => {
        const storedData = localStorage.getItem("DataSample");
        if (storedData) {
            const Data = JSON.parse(storedData);
            const Grouped = Data.reduce((acc, item) => {
                const rfNumber = item.RFNumber || 'Unknown RF Number';
                if (!acc[rfNumber]) {
                    acc[rfNumber] = [];
                }
                acc[rfNumber].push(item);
                return acc;
            }, {});
            const dataRFNumber = Object.entries(Grouped).map(([key, value], index) => {
                return {
                    key: index + 1,
                    RFNumber: key,
                    Sample: value
                }
            });
            setDataRFNumber(dataRFNumber);
        }
    };

    const handleDeleteSample = (sample) => {
        const storedData = localStorage.getItem("DataSample");
        if (!storedData) return;

        const parsed = JSON.parse(storedData);
        const filtered = parsed.filter(item => item.SampleCode !== sample.SampleCode);
        localStorage.setItem("DataSample", JSON.stringify(filtered));
        fetchDataLocalStorage();
        message.success(`Delete Sample ${sample.SampleName} Successfully!`)
    };

    useEffect(() => {
        fetchDataLocalStorage();
    }, []);

    const columns = [
        {
            dataIndex: 'RFNumber',
            title: 'RF Number',
            key: 'RFNumber',
            fixed: 'left'
        },
    ];

    return (
        <div className="border rounded-md p-4 mb-4">
            <div className="flex justify-between my-4">
                <h1 className="text-2xl font-medium">SAMPLE</h1>
                <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => onData(true)}
                >
                    Add Data
                </Button>
            </div>
            <Table
                columns={columns}
                dataSource={dataRFNumber}
                expandable={{
                    expandedRowRender: (record) => expandedSample(record, handleDeleteSample),
                }}
                scroll={{
                    x: 'max-content'
                }}
            />
        </div>
    );
};

export default TableSample;

// Expanded Sample
const expandedSample = (record, handleDeleteSample) => {
    const dataSample = record.Sample;

    return (
        <Table
            columns={columnSample(handleDeleteSample)}
            dataSource={dataSample}
            pagination={{ pageSize: 5 }}
            scroll={{ x: 'max-content' }}
            expandable={{
                expandedRowRender: expandedParameter
            }}
        />
    );
};

// Sample Columns
const columnSample = (handleDeleteSample) => [
    {
        dataIndex: 'SampleNumber',
        title: 'Sample Number',
        key: 'SampleNumber'
    },
    {
        dataIndex: 'SampleName',
        title: 'Sample Name',
        key: 'SampleName'
    },
    {
        dataIndex: 'ServiceType',
        title: 'Service Type',
        key: 'ServiceType',
        render: (value) => <p>{value ? value : '-'}</p>
    },
    {
        dataIndex: 'ReceivedDate',
        title: 'Received Date',
        key: 'ReceivedDate',
        render: (date) => date && dayjs(date).format('YYYY-MM-DD')
    },
    {
        key: 'action',
        title: 'Action',
        fixed: "right",
        width: 100,
        render: (_, record) => (
            <Space>
                <Link to={`/dashboard/menuorder/order/sample/form?sampleCode=${record.SampleCode}`}>
                    <Button icon={<EditFilled />} type="text" />
                </Link>
                <Popconfirm
                    placement="topRight"
                    title="Delete Sample"
                    description={
                        <p>
                            Are you sure you want to delete{" "}
                            <span className="font-medium">{record.SampleName}</span>?
                        </p>
                    }
                    onConfirm={() => handleDeleteSample(record)}
                    okText="Yes"
                    cancelText="No"
                >
                    <Button icon={<DeleteFilled />} type="text" />
                </Popconfirm>
            </Space>
        )
    }
];

// Expanded Parameter
const expandedParameter = (record) => {
    const dataParameter = record.Parameter;

    return (
        <Table
            columns={columnsParameter}
            dataSource={dataParameter}
            pagination={{ pageSize: 5 }}
            scroll={{ x: 'max-content' }}
        />
    );
};

// Parameter Columns
const columnsParameter = [
    {
        dataIndex: 'ParameterName',
        title: 'Parameter Name',
        key: 'ParameterName',
    },
    {
        dataIndex: 'Methode',
        title: 'Methode',
        key: 'Methode',
        render: (value) => value || <p>-</p>
    },
    {
        dataIndex: 'ReportNumber',
        title: 'Report Number',
        key: 'ReportNumber',
    },
    {
        dataIndex: 'SubcontStatus',
        title: 'SubcontStatus',
        key: 'SubcontStatus',
        render: (value) => (
            <Tag color={value ? 'green' : 'red'}> {value ? 'Yes' : 'No'} </Tag>
        ),
    },
    {
        dataIndex: 'Labsubcont',
        title: 'Labsubcont',
        key: 'Labsubcont',
        render: (value) => value || <p>-</p>
    },
    {
        dataIndex: 'TAT',
        title: 'TAT',
        key: 'TAT',
    },
    {
        dataIndex: 'DueDate',
        title: 'DueDate',
        key: 'DueDate',
        render: (date) => dayjs(date).format('YYYY-MM-DD')
    },
    {
        dataIndex: 'Amount',
        title: 'Amount',
        key: 'Amount',
        render: (value) => <p>Rp {formatRupiah(value)}</p>
    },
];
